import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform(array: any[], field: string, sort = 1): any[] {
    if (field) {
      array.sort((a: any, b: any) => {
        if (a[field] < b[field]) {
          return -1 * sort;
        } else if (a[field] > b[field]) {
          return 1 * sort;
        } else {
          return 0;
        }
      });
      return array;
    } else {
      // let limit = array[];
      array.sort((a: number, b: number) => {
        if (a < b) {
          return -1 * sort;
        } else if (a > b) {
          return 1 * sort;
        } else {
          return 0;
        }
      });
      return array;
    }
  }

}
